"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfSubscriptionsSettingsClient = void 0;
const NoSubscriptionSettingsFoundError_1 = require("./errors/NoSubscriptionSettingsFoundError");
class VcfSubscriptionsSettingsClient {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
        this.headers = {
            'User-Id': '__userId__',
        };
        this.getGdcType = (isWcar) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;
        this.resourceHostId = `myvw-vcf-${stage}`;
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Notifications/operation/getSubscriptionsSettings
    async getSubscriptionsSettings(vin, isWcar) {
        const response = await this.authService.get(this.resourceHostId, `vehicles/${vin}/subscriptions/settings?gdc=${this.getGdcType(isWcar)}`, this.headers);
        if (response.status === 404) {
            throw new NoSubscriptionSettingsFoundError_1.NoSubscriptionSettingsFoundError();
        }
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Notifications/operation/putSubscriptionsSettings
    async saveSubscriptionsSettings(vin, isWcar, settings) {
        const payload = { topics: settings };
        const response = await this.authService.put(this.resourceHostId, `vehicles/${vin}/subscriptions/settings?gdc=${this.getGdcType(isWcar)}`, JSON.stringify(payload), this.headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
}
exports.VcfSubscriptionsSettingsClient = VcfSubscriptionsSettingsClient;
//# sourceMappingURL=VcfSubscriptionsSettingsClient.js.map